import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { Text } from '../../atoms/Text';
import { Iclose, IcircleCheck, IcircleClose, IcircleWarning, IcircleInfo } from '../../atoms/AgroIcon/icons';
var data = {
  success: {
    icon: IcircleCheck,
    color: 'green500',
    iconCy: 'icon-success'
  },
  danger: {
    icon: IcircleClose,
    color: 'red500',
    iconCy: 'icon-danger'
  },
  warning: {
    icon: IcircleWarning,
    color: 'yellow500',
    iconCy: 'icon-warning'
  },
  info: {
    icon: IcircleInfo,
    color: 'blue500',
    iconCy: 'icon-info'
  }
};
var AgroAlert = withCssProps(function (_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'success' : _ref$variant,
    onClick = _ref.onClick,
    title = _ref.title,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? null : _ref$subtitle,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    btnLabel = _ref.btnLabel;
  var Icon = data[variant].icon;
  var color = data[variant].color;
  var handleClick = function handleClick(event) {
    event.preventDefault();
    onClick({
      event: event
    });
  };
  return /*#__PURE__*/React.createElement(Alert, {
    className: className,
    color: color,
    hasSubtitle: subtitle && subtitle.length,
    "data-cy": "alert"
  }, /*#__PURE__*/React.createElement(AlertIcon, {
    hasSubtitle: subtitle && subtitle.length
  }, /*#__PURE__*/React.createElement(Icon, {
    hasSubtitle: subtitle && subtitle.length,
    height: "24px",
    width: "24px",
    fill: "white",
    "data-cy": data[variant].iconCy
  })), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Text, {
    type: "subtitle-lg",
    color: "white",
    "data-cy": "title"
  }, title), /*#__PURE__*/React.createElement(Text, {
    type: "label-md",
    color: "white",
    "data-cy": "subtitle"
  }, subtitle)), btnLabel ? /*#__PURE__*/React.createElement(LabelButton, {
    onClick: function onClick(e) {
      return handleClick(e);
    },
    "data-cy": "btn-label"
  }, /*#__PURE__*/React.createElement(Text, {
    type: "label-sm",
    color: "white"
  }, btnLabel)) : /*#__PURE__*/React.createElement(CloseButton, {
    onClick: function onClick(e) {
      return handleClick(e);
    },
    "data-cy": "btn-close"
  }, /*#__PURE__*/React.createElement(Iclose, {
    fill: "white",
    width: "20px",
    height: "20px"
  })));
});
AgroAlert.propTypes = {
  variant: PropTypes.oneOf(['success', 'danger', 'warning', 'info']),
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  btnLabel: PropTypes.string
};
AgroAlert.displayName = 'AgroAlert';
export { AgroAlert };
var Alert = styled.div.withConfig({
  displayName: "AgroAlert__Alert",
  componentId: "h2i4w2-0"
})(["min-height:48px;display:flex;width:fit-content;height:fit-content;border-radius:12px;background-color:", ";", ""], function (_ref2) {
  var theme = _ref2.theme,
    color = _ref2.color;
  return theme.colors[color];
}, function (_ref3) {
  var hasSubtitle = _ref3.hasSubtitle;
  return hasSubtitle && css(["height:auto;"]);
});
var Content = styled.div.withConfig({
  displayName: "AgroAlert__Content",
  componentId: "h2i4w2-1"
})(["padding-top:12px;padding-bottom:12px;padding-right:12px;display:flex;flex-direction:column;height:fit-content;min-width:250px;", ""], function (_ref4) {
  var theme = _ref4.theme;
  return css(["@media (max-width:", "){min-width:auto;}"], theme.breakpoint.sm);
});
var AlertIcon = styled.div.withConfig({
  displayName: "AgroAlert__AlertIcon",
  componentId: "h2i4w2-2"
})(["height:48px;width:52px;", " svg{padding:12px 12px 12px 16px;box-sizing:content-box;", "}"], function (_ref5) {
  var hasSubtitle = _ref5.hasSubtitle;
  return hasSubtitle && css(["height:68px;width:56px;"]);
}, function (_ref6) {
  var hasSubtitle = _ref6.hasSubtitle;
  return hasSubtitle && css(["padding:20px 12px 24px 20px;"]);
});
var CloseButton = styled.button.withConfig({
  displayName: "AgroAlert__CloseButton",
  componentId: "h2i4w2-3"
})(["all:unset;cursor:pointer;transition:all 0.3s ease;padding:14px;padding:0px 14px;height:100%;min-height:48px;&:hover > *{opacity:0.5;}"]);
var LabelButton = styled(CloseButton).withConfig({
  displayName: "AgroAlert__LabelButton",
  componentId: "h2i4w2-4"
})(["border-left:2px solid rgba(255,255,255,0.5);height:auto;"]);